import { RouteRecordRaw } from "vue-router";
import {
  agencyHubRoute,
  createOrganizationRoute,
  profileRoute,
  settingsRoute,
} from "@/router";
import { addResourceRoute } from "@/router/organization_settings_routes";

export const settingRoutes: RouteRecordRaw[] = [
  profileRoute,
  settingsRoute,
  agencyHubRoute,
  addResourceRoute,
  createOrganizationRoute,
];
